import React, { useContext, useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { extractAddress } from '../helper'
import TronWalletInfo from '../WalletInfo/TronWalletInfo';
import TronContext from '../../../../TronContext';
import CheckYourNetworkModal from './CheckYourNetworkModal';

export default function TronWalletConfig({
  amount,
  allBalance,
  selectedChain,
  selectedToken,
  setAddress,
}) {

  const { account, connectWallet, disconnectWallet } = useContext(TronContext);
  const [isShowModal, setIsShowModal] = useState(false);
  useEffect(() => {
    if (account) {
      setAddress(account);
    } else {
      setAddress("");
    }
  }, [account, setAddress])

  const handleClose = () => {
    setIsShowModal(false);
    connectWallet()
  }

  return (
    <div>
      <CheckYourNetworkModal
        isShowModal={isShowModal}
        handleClose={handleClose}
        selectedChain={selectedChain}
      />
      <div className="title-block">
        <strong >
          {
            account ? `Wallet address ${extractAddress(account)}` : " Connect your wallet"
          }
        </strong>
      </div>
      <div className='mt-3'>
        <div className="p-3 text-dark">
          {
            !account ?
              <div>
                <p className='mb-4 wallet-info-text'>
                  You have selected the Tron network. Connect your wallet using WalletConnect (supports mobile and desktop wallets) or TronLink browser extension. This ensures secure interaction with the Tron network.
                  <br />To proceed press the <b>Connect Your Tron Wallet</b> button below.
                </p>
                <Button
                  variant="primary w-100 shadow"
                  onClick={() => setIsShowModal(true)}
                >
                  Connect Your Tron Wallet
                </Button>
              </div> :
              <div>
                <TronWalletInfo
                  amount={amount}
                  allBalance={allBalance}
                  selectedChain={selectedChain}
                  selectedToken={selectedToken}
                />
                <div className="d-flex justify-content-end mt-3">
                  <Button size='sm' variant="danger" onClick={disconnectWallet}>Disconnect Wallet</Button>
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  )
}